import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-arrow-forward-icon/jb-arrow-forward-icon.css.ts
var jb_arrow_forward_icon_css_default = i`:host{display:inline-block;height:16px;width:11px}@media(forced-colors: active){svg path{fill:CanvasText}}`;

export {
  jb_arrow_forward_icon_css_default
};
